<div data-automation-id="generic-error-card" class="bl-max-width--tablet-width bl-margin-x--auto">
  <dx-content-messaging-card
    [addressLabel]="pageContent?.addressBlockLabel"
    [description]="pageContent?.description || ('genericError/subheading' | dictionary)"
    [emailLabel]="pageContent?.emailBlockLabel"
    [phoneLabel]="pageContent?.phoneBlockLabel"
    [showAddress]="!!pageContent?.showAddressBlock"
    [showEmail]="!!pageContent?.showEmailBlock"
    [showPhone]="!!pageContent?.showPhoneBlock"
    [title]="pageContent?.title || ('genericError/heading' | dictionary)"
  >
    <img
      alt="icon of yellow page with exclamation mark in the center"
      src="/assets/images/opps-error-icon.svg"
      class="bl-margin-y--16 bl-margin-y-md--24"
    />
  </dx-content-messaging-card>
</div>
